module.exports = __webpack_public_path__ + "static/media/hartmann-icon.672294bc.png";